import type { ReactNode } from 'react'

import cn from 'classnames'
import { tr } from 'mmfintech-commons'

import { ThreeCircles } from 'react-loader-spinner'
import { ChevronLeft, ChevronRight } from '@icons'

type SelectBankItemProps = {
  back?: boolean
  icon?: ReactNode
  caption?: string
  description?: string
  selected?: boolean
  loading?: boolean
  maintenance?: boolean
  className?: string
  onClick: () => void
  'data-test'?: string
}

export const SelectBankItem = (props: SelectBankItemProps) => {
  const {
    back = false,
    icon,
    caption,
    description,
    selected = false,
    loading = false,
    maintenance = false,
    className,
    onClick,
    'data-test': dataTest
  } = props

  const handleClick = () => !loading && !maintenance && onClick()

  return (
    <div
      className={cn('select-bank-item-wrapper', className, { back, selected, maintenance })}
      onClick={handleClick}
      data-test={dataTest}
    >
      {back ? (
        <span className='back-arrow'>
          <ChevronLeft />
        </span>
      ) : (
        <span className='icon'>{icon}</span>
      )}

      <div className='select-bank-text'>
        {caption ? <span className='caption'>{caption}</span> : null}
        {description ? <span>{description}</span> : null}
        {maintenance && (
          <span className='warning'>{tr('CHECKOUT.VOUCHER.BANKS.MAINTENANCE', 'Under maintenance')}</span>
        )}
      </div>

      {!back && selected && (
        <span className='arrow'>
          {loading ? <ThreeCircles width='3.5rem' height='3.5rem' color='white' /> : <ChevronRight />}
        </span>
      )}
    </div>
  )
}
